import { UserRole } from 'features/user/ts/UserRole';
import { hasRequiredRoles } from 'features/user/utils/hasRequiredRoles';
import { useSelector } from 'store';

export const useRoleCheck = (...roleNames: UserRole['name'][]): boolean => {
  const roles = useSelector(state => state.user.user?.roles);

  if (!roles) return false;

  return hasRequiredRoles(roles, roleNames.map(name => ({ name })) as UserRole[]);
};
